import styled from "styled-components"

export interface Props {
  color: string
}

export default styled.div<Props>`
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%; 
  ${({color}) => color && `background-color: ${color};`}
`
